"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeftDownArrowIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const LeftDownArrowIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 24 24" }),
    react_1.default.createElement("g", { transform: "translate(0,-952.36218)" },
        react_1.default.createElement("path", { d: "m 19.845961,963.36219 -12.8459601,19.49998 12.8768401,0 12.815081,0 30.601794,0 0,21.45003 -9.819748,0 19.763015,37.05 19.763016,-37.05 -9.943267,0 0,-21.45003 0.06176,0 0,-19.49998 -0.06176,0 -19.763016,0 -43.416875,0 0,0.061 -0.03088,-0.061 z" }))));
exports.LeftDownArrowIcon = LeftDownArrowIcon;
exports.default = exports.LeftDownArrowIcon;
